<template>
  <div @click="onClose" id="sideBarModalComponent" class="wrapper">
    <div :class="{wrapper_body: true, open: true}">
      <div v-if="loading">
        <pulse-loader :loading="true" :color="loadingColor" class="text-center pt-50vh"/>
      </div>
      <div v-else>
        <div v-if="message" class="pt-50vh">
          {{ message }}
        </div>
        <div v-else class="p-2">
          <div v-if="!records.length">
            <h5>Уведомлений не найдено</h5>
          </div>
          <div v-else>
            <div v-for="record in records" :key="record.id" class="record">
              <p><span class="badge badge-info pt-1">{{ record.sub_object.title || 'не определен' }}</span></p>
              <div class="flex">
                <span>Входящий: <strong>{{ moment(record.created_at) }}</strong></span>
                <div class="ml-1" v-if="record?.phone_call?.call_duration && record.phone_call.call_duration > 0"><span
                  class="phone_call_sign"/> {{ record.phone_call.call_duration }} сек.
                </div>
              </div>
              <template v-if="record?.phone_call?.call_duration && record.phone_call.call_duration > 0">
                <PlayAudioByRequest :record="record.phone_call"/>
              </template>
              <p>Клиент: <strong>{{
                  record.sub_object?.client?.name || 'Не определен'
                }}</strong></p>
              <div class="pointer blacklist_block" v-if="blackList['00' + record.sub_object.phoneNum]">
                <BlackListButton :blackList="blackList['00' + record.sub_object.phoneNum]">
                  <slot>
                    <span class="badge badge-warning">черный список</span>
                  </slot>
                </BlackListButton>
              </div>
              <div class="flex">
                <span class="mr-1">Номер телефона: <strong>{{
                    record.sub_object.incomePhone || record.sub_object.phoneNum
                  }}</strong></span>
                <MakePhoneCall
                  className="small"
                  :recordId="record.sub_object.record_id"
                />
                <span v-if="record?.phone_call?.call_duration && record.phone_call.call_duration > 0" class="ml-2">
                  {{ record.phone_call.user?.name }}
                </span>
              </div>
              <p>На номер: <strong>{{ record.sub_object.toPhone || record.sub_object.toPhoneNum }}</strong></p>
              <template v-if="orderList[record.sub_object.phone_id]">
                <p v-for="o in orderList[record.sub_object.phone_id]"><span
                  class="badge badge-success mr-1">{{
                    $AllProjects[o.site_id]?.title ?? o.site_id
                  }}</span><strong>{{ o.id }}</strong>
                  ({{ o.status_label }})
                  <button
                    @click="openOrderInModal(o.id)"
                    class="btn btn-xs btn-info newWindowBtn ml-1"
                  >
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                </p>
              </template>
              <div class="flex justify-content-between">
                <div class="flex">
                  <div v-if="(record?.phone_call?.client_requests ?? []).length"
                       class="mr-1 flex align-items-center badge badge-info">
                    {{ record.phone_call.client_requests.length }}
                  </div>
                  <button @click="openClientRequest(record)" class="btn btn-outline-info btn-xs">Сохранить запрос
                    клиента
                  </button>
                </div>
                <button @click="() => createOrder(record.sub_object)" class="btn btn-outline-success btn-xs">Создать
                  заявку с
                  текущим
                  клиентом
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api"
import moment from 'moment'
import MakePhoneCall from "@/components/phoneCalls/MakePhoneCall";
import {fillOrderBus} from "@/eventsBus";
import BlackListButton from "@/components/clients/BlackListButton.vue";
import UserName from "@/components/users/UserName.vue";
import PlayAudioByRequest from "@/views/telephony/components/PlayAudioByRequest.vue";

export default {
  props: ['onModalClose'],
  components: {
    PlayAudioByRequest,
    UserName,
    MakePhoneCall,
    BlackListButton,
  },
  data() {
    return {
      loading: false,
      message: null,
      records: [],
      orderList: {},
      blackList: {},
      loadingColor: this.$constants.LOADING_COLOR,
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  mounted() {
    this.getNotifications()
  },
  methods: {
    openClientRequest(record) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          data: {
            client: (record.sub_object.client ?? {}),
            call: {
              record_id: record.sub_object.record_id,
              phone_num: record.sub_object.phoneNum,
              to_phone_id: record.sub_object.to_phone_id
            },
          },
          drawer: {small: true},
          type: 'ClientIncomeRequest',
        },
        // callBackAction: 'closeOrderModal'
      })
    },
    moment: function (date, format = 'DD.MM.YYYY HH:mm') {
      if (!date) return;
      return moment(date).format(format);
    },
    async getNotifications() {
      this.loading = true;
      const {data} = await api.index('notifications/phoneCalls');
      this.message = null;
      if (data.success) {
        this.records = data.records;
        this.orderList = data.orderList;
        this.blackList = data.blackList.reduce((acc, b) => {
          acc[b.phone_num] = b;
          return acc;
        }, {})
      } else {
        this.message = data.message || 'Ошибка сервера';
      }
      this.loading = false;
    },
    createOrder(record) {
      if (record.client?.name === 'Не зарегистрирован') {
        record.client.name = null;
      }
      const data = {
        client: record.client,
        phoneNum: record.phoneNum,
        extra_data: {
          city_id: record.city_id,
          project_id: record.project_id,
          mirror_id: record.mirror_id,
        }
      };
      if (this.$route.name === 'newOrder') {
        fillOrderBus.$emit(
          'updateFillOrder',
          data
        );
      } else {
        this.mixinGoToRouter("newOrder", data);
      }
    },
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId, callBackAction: 'resetOrder'})
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.id === 'sideBarModalComponent') {
        // if (e.target.id === 'sideBarModalComponent') {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.onModalClose();
      }
    }
  }
}
</script>

<style scoped>
.phone_call_sign {
  background-color: green;
  width: 12px;
  height: 12px;
  border-radius: 20px;
  display: inline-flex;
}

.blacklist_block {
  width: fit-content;
//padding: 5px; //background-color: #ffe5e5;
}

.record p {
  margin-bottom: 2px;
}

.record {
  background-color: white;
  margin-bottom: 5px;
  border: 1px solid lightgrey;
  padding: 5px;
  box-shadow: 4px 4px 8px 0px rgb(34 60 80 / 20%);
}

.pt-50vh {
  padding-top: 50vh;
}

.wrapper_body.open {
  background-color: #f8f8f8;
  padding-top: 75px;
  /*left: calc(100% - 300px);*/
  left: 70%;
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  background-color: white;
  width: 30%;
  left: 100%;
  min-height: 100%;
  z-index: 9999;
}

.badge {
  font-size: 12px;
}

strong {
  font-size: 15px;
}

.newWindowBtn {
  padding: 3px 6px !important;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 9999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
